import { Navigate } from 'react-router-dom';

import { useAppId } from '@verantos-dev/app-state-base';
import { useAuth } from '@verantos-dev/core-auth';
import { getProjectsBasePath } from '@verantos-dev/core-constants';
import { EvidencePlatformSidebarAppID } from '@verantos-dev/core-enums';
import { RaSessionReviewPage as RaSessionReviewPageContent } from '@verantos-dev/feature-ra-session-review';

// TODO: cleanup with research_assistant_developer_tools ff — OR-6432 Block B.
//
// The route in app.tsx already gates on the feature flag via
// FeatureFlagProtectedRoute (`research_assistant_developer_tools`), but that
// helper only knows about flags, not roles/org membership. AC1 requires BOTH
// isInternalUser AND the flag before a customer can ever see this page, so
// the isInternalUser half of the gate lives here instead of pulling in the
// role-claim-check (`withAuth` + `appIdToClaimCheckDefinitionMap`) pattern
// the other top-level sidebar apps use — that map is keyed by a specific
// customer-facing business role (e.g. OR_RESEARCHER), which doesn't fit this
// page's actual audience (any internal Verantos staff member: PM, QA,
// developer, eval engineer) and would either wrongly exclude qualified
// internal staff or wrongly include a role-matching customer.
//
// This is UX-only, matching this feature's whole gating model (see
// docs/research-assistant/OR-6432-session-observability-spike.md): every
// backend call this page makes re-checks is_internal + the flag
// independently server-side.
export const RaSessionReviewPage = () => {
  useAppId(EvidencePlatformSidebarAppID.raSessionReview);

  const {
    user: { isInternalUser },
  } = useAuth();

  if (!isInternalUser) {
    // Absolute path (leading slash), unlike the FeatureFlagProtectedRoute
    // `fallbackPath={PROJECTS_BASE_PATH}` pattern used elsewhere in app.tsx —
    // a bare relative "projects" resolves against this route's own matched
    // path ("/ra-session-review/projects"), not the app root.
    return <Navigate to={getProjectsBasePath()} replace />;
  }

  return <RaSessionReviewPageContent />;
};

export default RaSessionReviewPage;
